import { createAsyncThunk } from "@reduxjs/toolkit";
import { MORTGAGEBROKERDASHBOARDPATH } from "../../../constants/routes-constant";
import { getDataAPI } from "../../../lib/axios";

export const getMortgageBrokerDasboardDataThunk = createAsyncThunk("get-mortgage-broker-dashboard-data",
    async ({ axiosInstance }: any, { rejectWithValue }) => {
        try {
            const response = await getDataAPI(MORTGAGEBROKERDASHBOARDPATH, axiosInstance);
            

            return response.data?.data;
        } catch (error: any) {
            
            const errorData = {

                //   error: error?.response?.data?.message || GLOBALSERVERERRORMESSAGE,
            };
            return rejectWithValue(errorData);
        }
    }
);


export const getMortgageBrokerYearDashboardDataThunk = createAsyncThunk("get-mortgage-broker-year-dashboard-data",
    async ({ yearData, axiosInstance }: any, { rejectWithValue }) => {
        try {
            const response = await getDataAPI(`dashboard/get-user?year=${yearData}`, axiosInstance);
            

            return response.data?.data;
        } catch (error: any) {
            
            const errorData = {

                
            };
            return rejectWithValue(errorData);
        }
    }
);